import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import CONFIG from "../utils/config";

const Pdf = () => {
  const { id } = useParams();

  useEffect(() => {
    if (!id) return;

    const fetchProposalNumber = async () => {
      try {
        
        // POST request with body containing id
        const res = await fetch(`${CONFIG.BASE}/insurance/getsgs`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id }), // Send id in request body
        });

        if (!res.ok) {
          throw new Error("Failed to fetch proposal number");
        }

        const data = await res.json();
        const renProposalNumber = data?.renProposalNumber;

        if (renProposalNumber) {
          navigatePdf(renProposalNumber);
        } else {
          console.error("renProposalNumber not found in response:", data);
        }
      } catch (error) {
        console.error("Error fetching proposal number:", error);
      }
    };

    const navigatePdf = (renProposalNumber) => {
      console.log("📥 navigatePdf called with:", renProposalNumber);
      if (!renProposalNumber) return;

      const formattedProposalNumber = renProposalNumber.replace(/\//g, "_");
      const pdfUrl = `${CONFIG.PDFDOWNLOAD}/download/download_policy_format/${formattedProposalNumber}`;
      console.log("➡ PDF URL:", pdfUrl);

      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = pdfUrl;
      document.body.appendChild(iframe);
    };

    fetchProposalNumber();
  }, [id]);

  return null; // No UI rendered
};

export default Pdf;
